module.exports = __webpack_public_path__ + "static/img/2.3a5967b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/eng/2.png
// module id = h3Wu
// module chunks = 0